import React from 'react';
import { mapsSearchUrl } from '../utils/links';

const emptyStyle = {
  margin: '4px 0 0',
  padding: '18px 4px',
  fontSize: 14,
  color: '#98989d',
  borderTop: '1px solid #38383a',
};

function Leaderboard({ items = [], loading = false }) {
  return (
    <div style={{ marginTop: 40 }}>
      <h2
        style={{
          margin: '0 0 8px',
          fontSize: 21,
          lineHeight: '28px',
          fontWeight: 600,
          letterSpacing: '-0.01em',
          color: '#f5f5f7',
        }}
      >
        🥇 Ranch Leaderboard
      </h2>

      {loading && <p style={emptyStyle}>Loading ratings…</p>}

      {!loading && items.length === 0 && (
        <p style={emptyStyle}>No ratings yet — be the first to rate the ranch! 🥄</p>
      )}

      <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
        {items.map((item, index) => (
          <li
            key={item.restaurant}
            style={{
              padding: '14px 4px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderTop: '1px solid #38383a',
            }}
          >
            <div>
              <span
                style={{
                  fontWeight: 600,
                  fontSize: 16,
                  color: '#f5f5f7',
                  letterSpacing: '-0.01em',
                }}
              >
                {index + 1}. {item.restaurant}
              </span>
              <p style={{ fontSize: 13, color: '#98989d', margin: '2px 0 0' }}>
                {item.totalRatings} review(s)
              </p>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 14, flexShrink: 0 }}>
              <a
                href={mapsSearchUrl(item.restaurant)}
                target="_blank"
                rel="noopener noreferrer"
                title="Open in Google Maps"
                style={{
                  fontSize: 13,
                  fontWeight: 600,
                  color: '#0a84ff',
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 4,
                }}
              >
                📍 Maps
              </a>
              <span style={{ fontSize: 18, fontWeight: 700, color: '#eab308' }}>
                {item.avgRating} ⭐
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Leaderboard;
